module.exports = __webpack_public_path__ + "static/media/taskListNotification.83b297ed.svg";